import { RenderFields } from "../../utils/form.utils";
import { currency } from "../../utils/number.utils";

export default function PaymentAmountField({ watch, control, errors, setValue, others }) {
  const amount = watch("amount") ?? 0;

  const due = `Due: ${currency(others?.due === 0 ? 0 : others?.due - Number(amount))}`;

  const fields = [
    {
      label: "Amount",
      name: "amount",
      type: "number",
      placeholder: "Enter an amount",
      col: { md: 12 },
      rules: { required: "This is required field!" },
      helpText: due
    }
  ];
  return (
    <RenderFields
      setValue={setValue}
      fields={fields}
      control={control}
      watch={watch}
      errors={errors}
    />
  );
}
